import { render, staticRenderFns } from "./PassengerCard.vue?vue&type=template&id=0947d706&scoped=true"
import script from "./PassengerCard.vue?vue&type=script&lang=js"
export * from "./PassengerCard.vue?vue&type=script&lang=js"
import style0 from "./PassengerCard.vue?vue&type=style&index=0&id=0947d706&prod&lang=scss"
import style1 from "./PassengerCard.vue?vue&type=style&index=1&id=0947d706&prod&lang=scss&scoped=true"
import style2 from "./PassengerCard.vue?vue&type=style&index=2&id=0947d706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947d706",
  null
  
)

export default component.exports